import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useToolbarStore } from '../../../store/VitalStore';
//UI
import { FaUser, FaUserAstronaut } from 'react-icons/fa';
import BtnCircle from '../../buttons/BtnCircle';
import { useTranslation } from "react-i18next";


const NavTopPublic = () => {
  const { openToolbar } = useToolbarStore((state) => state);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const logOut = () => {
    localStorage.clear()
  };

  return (
    <nav className="absolute z-10 font-sans shadow-md flex w-calc md:right-0 h-14 items-center text-gray-600 bg-gradient-to-r from-yellow-300 to-amber-500">
      <div className="md:hidden absolute left-3">
        <BtnCircle btnAction={() => openToolbar()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </BtnCircle>
      </div>
      <div className="absolute right-0 border-l px-5 flex h-[100%] items-center bg-gradient-to-r from-cyan-600 to-blue-600 text-white">
        <div className="flex space-x-5">
          <div className="dropdown dropdown-end items-center">
            <div className='flex text-[15px] flex-col text-center'>
              <h1 className='font-semibold'>Bienvenido</h1>
              <p className=''>{user.userName}</p>
            </div>
          </div>
          <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle avatar">
              <div className='bg-gradient-to-r from-yellow-500 to-amber-500 w-10 h-10 rounded-full flex items-center justify-center p-2'>
                <FaUserAstronaut size={"24px"} color='white' />
               </div>
            </div>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content bg-base-100 z-1 mt-2 w-52 p-2 shadow-sm shadow-blue-500 text-gray-500 font-semibold">
              <li onClick={logOut} ><a href='/'>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M16 9v-4l8 7-8 7v-4h-8v-6h8zm-2 10v-.083c-1.178.685-2.542 1.083-4 1.083-4.411 0-8-3.589-8-8s3.589-8 8-8c1.458 0 2.822.398 4 1.083v-2.245c-1.226-.536-2.577-.838-4-.838-5.522 0-10 4.477-10 10s4.478 10 10 10c1.423 0 2.774-.302 4-.838v-2.162z" />
                </svg>
                Cerrar Sesion
              </a>
              </li>
            </ul>
          </div>
        </div>
      </div >
    </nav>
  );
};

export default NavTopPublic;
